import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled } from '@mui/material/styles';
import { MobileNav } from '../mobile-nav';
import { SideNav } from './side-nav';
import { useMobileNav } from './use-mobile-nav';
import { AppBar, Box, IconButton, SvgIcon, Toolbar, Typography } from '@mui/material';
import Menu01Icon from '@untitled-ui/icons-react/build/esm/Menu01';

const SIDE_NAV_WIDTH = 280;

const VerticalLayoutRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: SIDE_NAV_WIDTH,
  },
}));

const VerticalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%',
  minHeight: '100vh',
});

export const VerticalLayout = (props) => {
  const { children, sections, navColor } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const mobileNav = useMobileNav();

  return (
    <>
      {!lgUp && (
        <AppBar
          position="sticky"
          elevation={0}
          color="inherit"
          sx={{
            bgcolor: 'background.paper',
            borderBottom: 1,
            borderColor: 'divider',
            backdropFilter: 'blur(8px)',
          }}
        >
          <Toolbar
            disableGutters
            sx={{ minHeight: 56, px: 1, gap: 1 }}
          >
            <IconButton
              onClick={mobileNav.handleOpen}
              aria-label="Abrir menú"
              sx={{ color: 'text.secondary' }}
            >
              <SvgIcon fontSize="small">
                <Menu01Icon />
              </SvgIcon>
            </IconButton>
            <Box
              sx={{
                flex: '1 1 auto',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                minWidth: 0,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: 17,
                  color: 'primary.main',
                  whiteSpace: 'nowrap',
                }}
              >
                Garantes
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                · Soluciones Financieras
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      )}
      {lgUp && (
        <SideNav
          color={navColor}
          sections={sections}
        />
      )}
      {!lgUp && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )}
      <VerticalLayoutRoot>
        <VerticalLayoutContainer>{children}</VerticalLayoutContainer>
      </VerticalLayoutRoot>
    </>
  );
};

VerticalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf(['blend-in', 'discrete', 'evident']),
  sections: PropTypes.array,
};
